/* eslint-disable no-console */

import { register } from 'register-service-worker'
import store from './store'

const UPDATE_CHECK_INTERVAL = 20 * 60 * 1000
const MIN_CHECK_GAP = 15 * 60 * 1000
const BOOT_AUTO_APPLY_WINDOW = 60 * 1000
const APPLY_FALLBACK_DELAY = 3000

const bootAt = Date.now()
let waitingRegistration = null
let lastCheckAt = 0

function pendingWorker() {
    if (!waitingRegistration) return null
    return waitingRegistration.waiting || waitingRegistration.installing || null
}

export function hasPendingUpdate() {
    return !!pendingWorker()
}

export function applyUpdate() {
    const worker = pendingWorker()
    if (!worker) return false
    store.commit('setUpdateAvailable', false)
    store.commit('setOverlayUpdate', true)
    worker.postMessage({ type: 'SKIP_WAITING' })
    setTimeout(() => window.location.reload(), APPLY_FALLBACK_DELAY)
    return true
}

function onUpdateReady(registration) {
    waitingRegistration = registration
    if (Date.now() - bootAt < BOOT_AUTO_APPLY_WINDOW) {
        applyUpdate()
        return
    }
    store.commit('setUpdateAvailable', true)
}

function checkForUpdate(registration) {
    if (typeof navigator !== 'undefined' && navigator.onLine === false) return
    const now = Date.now()
    if (now - lastCheckAt < MIN_CHECK_GAP) return
    lastCheckAt = now
    if (hasPendingUpdate()) store.commit('setUpdateAvailable', true)
    registration.update().catch(() => { })
}

function watchForUpdates(registration) {
    lastCheckAt = Date.now()
    setInterval(() => checkForUpdate(registration), UPDATE_CHECK_INTERVAL)
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') checkForUpdate(registration)
    })
}

if (process.env.NODE_ENV === 'production') {
  let refreshing = false
  if (navigator.serviceWorker) {
    const hadController = !!navigator.serviceWorker.controller
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing || !hadController) return
      refreshing = true
      window.location.reload()
    })
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (!event.data || event.data.type !== 'UPDATE_TOAST_PING') return
      const port = event.ports && event.ports[0]
      if (port) port.postMessage({ type: 'UPDATE_TOAST_READY' })
    })
  }

  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered (registration) {
      console.log('Service worker has been registered.')
      watchForUpdates(registration)
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated (registration) {
      console.log('New content is available; please refresh.')
      onUpdateReady(registration)
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
